<template>
  <div v-loading="loading" class="rj-page-card orderProductList">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="false">
        <div slot="header">
          <span>配送至：</span>
          <!-- <span>{{ address }}</span> -->
          <div v-if="address" class="adressBox">
            <div v-if="address.isDefault" class="defTab">
              默认
            </div>
            <div class="item">
              {{ address.receiverName }}
            </div>
            <div class="item">
              {{ address.province }}
            </div>
            <div class="item">
              {{ address.city }}
            </div>
            <div class="item">
              {{ address.county }}
            </div>
            <div class="item">
              {{ address.receiptAddress }}
            </div>
            <div class="item">
              {{ address.receiverPhone }}
            </div>
          </div>
          <el-button v-if="address && address.receiverName" type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">
            更改地址
          </el-button>
          <el-button v-else type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">
            选择地址
          </el-button>
        </div>
        <slot name="freightInfo" />
        <div style="padding: 20px">
          <el-form :inline="true">
            <el-form-item>
              <el-date-picker
                v-model="allAttribute.time"
                :picker-options="setBatchPickerOptions()"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择期望发货日期"
              />
            </el-form-item>

            <el-form-item>
              <el-select v-model="allAttribute.freight" placeholder="请选择货运属性">
                <el-option
                  v-for="(value, key) in freightProperty"
                  :key="key"
                  :label="value"
                  :value="key"
                />
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="batchSettings">
                批量设置
              </el-button>
              <el-button type="default" @click="setMaterialNum()">
                设置料号
              </el-button>
              <el-button v-if="isHiddenBtn" type="default" @click="addNewRow">
                添加产品行
              </el-button>
              <el-button v-if="isHiddenBtn" type="default" @click="batchDeatail">
                删除勾选产品行
              </el-button>
            </el-form-item>
          </el-form>

          <div v-if="isDisabledConType" style="color:red">
            注:1.若批量设置的日期不在客期可选范围,则需要重新设置或在产品行上单独设置
            2.若代理商发布合同时间和订单员发布合同时间间隔大于2天,则期望发货日期会在选择的日期上顺延相应间隔天数
          </div>

          <div class="table">
            <el-table :data="productList" border
                      style="width: 100%"
                      show-summary
                      :summary-method="getSummaries"
                      :row-class-name="tableRowClassName"
                      :height="tableHeight"
                      @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="55"
                align="left"
              />
              <el-table-column type="index" width="50" label="序号" align="left" />
              <el-table-column prop="rproductCode" label="销售代码" align="left" width="98" />
              <el-table-column prop="rproductName" label="产品型号" align="left" width="200">
                <template v-slot="{row}">
                  <choose-product :row="row" />
                </template>
              </el-table-column>
              <el-table-column label="料号" align="left" width="130">
                <template v-slot="{row,$index}">
                  <el-button type="text" @click="setMaterialNum(row,$index)">
                    {{ row.rmaterialNum?row.rmaterialNum:'选择料号' }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column prop="rproductNum" label="数量" align="left" width="150">
                <template v-slot="{row}">
                  <!-- 021 FR-004/FR-005/FR-011：换货合同数量回显必须保真；
                       服务订单（form.rorderType='服务订单'）支持两位小数并允许小于 1 的数量，
                       其他订单维持整数最小 1 的既有规则，min 参数不能用静态数字 -->
                  <el-input-number
                    v-model="row.rproductNum"
                    :min="quantityMin"
                    :precision="quantityPrecision"
                    :controls="false"
                    style="width:100%;"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="rproductUnit" label="单位" align="left" width="60" />
              <el-table-column prop="rproductPrice" label="单价" align="left" width="100">
                <template v-slot="{row}">
                  <el-input-number v-model="row.rproductPrice" :min="0" :controls="false" style="width:100%;" />
                </template>
              </el-table-column>
              <el-table-column prop="rproductPriceAdd" label="订单金额" align="right" width="100" header-align="left">
                <template v-slot="{row}">
                  {{ row.rproductPriceAdd }}
                </template>
              </el-table-column>
              <el-table-column prop="rproductActualPriceAdd" label="实际结算金额" align="left" width="135">
                <template v-slot="{row}">
                  <el-input-number v-model="row.rproductActualPriceAdd" :precision="6" :step="0.01" :min="0" :controls="false" style="width:100%;" />
                </template>
              </el-table-column>
              <el-table-column prop="rIsBorrowToSale" label="测试借条转订单" align="left" width="110">
                <template v-slot="{row,$index}">
                  <el-checkbox v-model="row.rIsBorrowToSale" @change="clickBorrow(row,$index)" />
                </template>
              </el-table-column>
              <el-table-column prop="rexpectedDeliveryDate" label="期望发货日期" align="left" width="160">
                <template v-slot="{row}">
                  <el-date-picker
                    v-model="row.rexpectedDeliveryDate"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="期望发货日期"
                    :clearable="false"
                    :picker-options="setSinglePickerOptions(row)"
                  />
                </template>
              </el-table-column>

              <el-table-column v-if="isDisabledConType" label="客期可选范围" align="left" min-width="180">
                <template v-slot="{row}">
                  <div class="text-left">
                    {{ setFormatRangDate(row) }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="rbeforeSplitPrice" label="拆分前单价" align="right" width="100" header-align="left">
                <template v-slot="{row}">
                  <el-input-number v-if="row.addNew" v-model="row.rbeforeSplitPrice" :min="0" :controls="false" style="width:100%;" />
                  <span v-else>{{ row.rbeforeSplitPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="货运属性" align="left" width="130">
                <template v-slot="{row}">
                  <el-select v-model="row.rfreightProperties" placeholder="货运属性">
                    <el-option v-for="(value, key) in freightProperty" :key="key"
                               :label="value"
                               :value="key"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="是否购买PSC" align="left" width="160">
                <template v-slot="{row}">
                  {{ row.rIsBuyPsc?'是':'否' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taxRate"
                label="税率"
                align="right"
                width="90"
                header-align="left"
              />

              <el-table-column v-if="isHiddenBtn" label="操作" align="left">
                <template v-slot="{row,$index}">
                  <el-button
                    :disabled="row.rIsBorrowToSale"
                    type="text"
                    style="padding: 0;"
                    @click="copyRow(row,$index)"
                  >
                    <i class="el-icon-circle-plus-outline" style="font-size: 16px;" />
                  </el-button>
                  <el-button
                    :disabled="row.rIsBorrowToSale"
                    type="text"
                    style="padding: 0;color: #F56C6C"
                    @click="removeProduct($index)"
                  >
                    <i class="el-icon-delete" style="font-size: 16px;" />
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </Collapse>
      <slot />
    </div>
    <address-box :prop-open.sync="showAddress" @chooseAddress="changeAddress" @ChangeDatas="ChangeDatas" />
    <material-num ref="MaterialNum" @chooseMateria="chooseMateria" />
  </div>
</template>
<script type="es6">
import Collapse from '@/components/Collapse';
import chooseProduct from './domestic/chooseProduct';
import MaterialNum from '../../contractCommonInput/MaterialNum';
import addressBox from '@/views/address/index.vue';
import { mapState } from 'vuex';
import { MathMulti, MathAdd, DateToStr } from '@/libs/util';
import { aggetReceiptAddressByContractNum, getReceiptAddressInfoModel } from '@/API';
import dayjs from 'dayjs';

// 产品行“测试借条转订单”变更存储数据，created 重置数据
let productOldData = {};

export default {
  data () {
    return {
      allAttribute: {
        time: '',
        freight: ''
      },
      productList: [],
      showAddress: false,
      loading: false,
      address: {},
      tableHeight: 400,
      dialogVisibleBool: false,
      multipleSelection: []
    };
  },
  props: {
    productData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    isTestProject: {
      type: [Boolean, Number],
      default: false
    },
    contractId: {
      type: [String, Number],
      default: ''
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    Collapse,
    addressBox,
    chooseProduct,
    MaterialNum
  },
  computed: {
    ...mapState({
      freightProperty: state => state.enumeration.freightProperty
    }),
    // 021 FR-004/FR-005/FR-011：是否服务订单（原单订单类型为“服务订单”）。
    // 服务订单的换货产品全部为服务产品，数量支持最多两位小数；
    // 其他订单（含随硬件销售的服务产品）保持整数规则。
    // 判断只看原单订单类型（baseInfoModelVO.rorderType），不按产品行推导，
    // 与 op-return-exchange-vue 的 quantityPrecision 口径一致。
    isServiceOrder () {
      return this.form && this.form.rorderType === '服务订单';
    },
    // 数量输入框保留的小数位数：服务订单 2 位，其他 0 位（整数）
    quantityPrecision () {
      return this.isServiceOrder ? 2 : 0;
    },
    // 数量输入框最小值：服务订单允许 0.1 起步的小数数量；
    // 其他订单维持既有最小 1 规则，防止 0.5 被静默修正为 1
    quantityMin () {
      return this.isServiceOrder ? 0.01 : 1;
    },
    // 数量总计
    AmountTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item.rproductNum) {
          cont += item.rproductNum;
        }
      });
      return cont;
    },
    // 订单金额总计
    computePriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        // let itemcont = MathMulti(item.productNum, item.productPriceSigle);
        if (item.rproductPriceAdd) {
          cont = MathAdd(item.rproductPriceAdd, cont);
        }
      });
      cont = Number(cont).toFixed(2);
      this.Recalculation();
      return cont;
    },
    // 实际结算金额总计
    settlementSumTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item.rproductActualPriceAdd) {
          cont = MathAdd(cont, item.rproductActualPriceAdd);
        }
      });
      return cont;
    },
    // 拆分前单价总计
    beProductUnitPriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        let itemcont = MathMulti(item.rproductNum, item.rbeforeSplitPrice);
        cont = MathAdd(itemcont, cont);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    // 合同类型不显示产品行的操作按钮
    isHiddenBtn () {
      return !['换货合同', '价外费用合同', '虚拟换货合同'].includes(this.$route.query.contractType);
    },
    // 只处理换货合同的客期禁用规则
    isDisabledConType () {
      return ['换货合同'].includes(this.$route.query.contractType);
    }
  },
  methods: {
    // 设置批量设置客期的禁用规则，规则：满足条件的当天开始的90天可以选择
    setBatchPickerOptions () {
      let _this = this;
      return {
        disabledDate (time) {
          if (_this.isDisabledConType) {
            // 规则：直签项目 365 天可选择，其他当天开始的90天可以选择
            if (_this.form.reIsDirect) {
              return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(365, 'day'));
            } else {
              return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(89, 'day'));
            }
          }
          return false;
        }
      };
    },

    // 设置产品行客期的禁用规则，规则：满足条件的当天开始的90天可以选择
    setSinglePickerOptions (row) {
      let _this = this;

      return {
        disabledDate (time) {
          return _this.getRowDisabledRule(row, time);
        }
      };
    },

    // 产品行规则 小于开始，大于结束，中间的法定节假日 禁用
    getRowDisabledRule (row, time) {
      if (this.isDisabledConType) {
        let { minExpectedDate, maxExpectedDate, holidayDates } = row;
        if (minExpectedDate && maxExpectedDate && holidayDates) {
          return dayjs(time).isBefore(dayjs(minExpectedDate)) || holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss')) || dayjs(time).isAfter(dayjs(maxExpectedDate));
        } else if (minExpectedDate && !maxExpectedDate && !holidayDates) {
          // 冲销
          return dayjs(time).isBefore(dayjs(minExpectedDate));
        } else {
          return false;
        }
      }
      return false;
    },

    // 客期可选范围
    setFormatRangDate (row) {
      let { minExpectedDate, maxExpectedDate } = row;
      if (minExpectedDate && maxExpectedDate) {
        return `${minExpectedDate.slice(0, 10)} ~ ${maxExpectedDate.slice(0, 10)}`;
      } else if (minExpectedDate && !maxExpectedDate) {
        return `${minExpectedDate.slice(0, 10)} ~ `;
      }
    },

    initData () {
      this.loading = false;
      let params = { newContractNum: this.$route.query.rnewContractNum };
      aggetReceiptAddressByContractNum(params).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          let data = json.data;
          if (data === null) {
            data = [];
          }
          this.address = data;
          this.$emit('chooseAddress', json.data);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 批量删除
    batchDeatail () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请勾选需要删除产品行');
        return;
      }
      this.$confirm('确认删除勾选产品行?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (var i = 0; i < this.productList.length; i++) {
          for (var j = 0; j < this.multipleSelection.length; j++) {
            if (this.productList[i].itemIndex === this.multipleSelection[j].itemIndex) {
              this.productList.splice(i, 1);
            }
          }
        };
        this.multipleSelection = [];
      }).catch(() => {

      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    tableRowClassName ({ row }) {
      if (row.highlight === 1) {
        return 'red-row';
      } else {
        return '';
      }
    },
    batchSettings () {
      let error = '';
      this.productList.forEach((item) => {
        if (this.allAttribute.time) {
          if (this.isDisabledConType) {
            // 验证行规则，不禁用的情况下进行赋值
            if (!this.getRowDisabledRule(item, this.allAttribute.time)) {
              this.$set(item, 'rexpectedDeliveryDate', this.allAttribute.time);
            }
          } else {
            let nowDateStr = DateToStr(new Date());
            if (new Date(this.allAttribute.time) >= new Date(nowDateStr)) {
              this.$set(item, 'rexpectedDeliveryDate', this.allAttribute.time);
            } else {
              error = '期望发货日期不能小于当前日期';
            }
          }
        }
        if (this.allAttribute.freight) {
          if (!item.rIsBorrowToSale) {
            this.$set(item, 'rfreightProperties', this.allAttribute.freight);
          }
        }
      });
      if (error) {
        this.$notify.error({
          message: error
        });
      }
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      // 计算当前数据冲销合计
      let moneyTotal = 0;
      for (var i = 0; i < this.productList.length; i++) {
        if (this.productList[i].rIsBorrowToSale) {
          moneyTotal = moneyTotal + this.productList[i].rproductActualPriceAdd;
        }
      }
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.AmountTotal;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = Number(this.computePriceTotal).toFixed(2);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = Math.round(this.settlementSumTotal * 100) / 100;

          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = Number(this.beProductUnitPriceTotal).toFixed(2);
        }
      });
      return sums;
    },
    changeAddress (val) {
      // 选择其他地址
      this.address = val;
      this.showAddress = false;
      this.$emit('chooseAddress', val);
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (!json.data.isDelete) {
              this.address = json.data;
            } else {
              this.address = {};
            }
          }
        }).catch(() => {

        });
      }
    },
    validate () {
      let error = '';
      if (!this.productList.length) {
        error = '请选择产品';
      }
      if (Number(this.beProductUnitPriceTotal) !== Number(this.computePriceTotal)) {
        error = '拆分前单价与订单金额不符';
      }
      this.productList.forEach((item) => {
        this.$delete(item, 'removeVisible');
        this.$delete(item, 'addNew');
        if (!error) {
          if (!item.rproductCode) {
            error = '存在产品未选产品型号';
          } else if (!item.rmaterialNum) {
            error = '存在产品未选择期料号';
          } else if (!item.rexpectedDeliveryDate) {
            error = '存在产品未选择期望发货日期';
          } else if (!item.rfreightProperties) {
            error = '存在产品未选择货运属性';
          }
        }
      });
      return new Promise((resolve, reject) => {
        if (error) {
          this.$notify.error({
            message: error
          });
          resolve(false);
        } else {
          resolve({ productList: this.productList, actualSettlementAmount: Number(this.settlementSumTotal).toFixed(2), orderSales: this.computePriceTotal });
        }
      });
    },
    validateDraft () {
      return new Promise((resolve, reject) => {
        resolve({ productList: this.productList, actualSettlementAmount: Number(this.settlementSumTotal).toFixed(2), orderSales: this.computePriceTotal });
      });
    },
    // getOrderAmount (row) {
    //   let Amount = MathMulti(row.rproductNum, row.rproductPrice);
    //   // update
    //   row.rproductPriceAdd = Number(Amount);
    //   // row.orderAmount = Number(Math.round(Amount * 100) / 100);

    //   this.getSettlementAmount(row);
    //   return row.rproductPriceAdd;
    // },
    // getSettlementAmount (row) {
    //   // 计算实际结算金额
    //   let rel = row.rproductPriceAdd;

    //   if (this.salesType === 1 && this.rebate !== 1 && this.isTestProject === false) {
    //     // 如果是现销 乘返点。
    //     rel = MathMulti(rel, this.rebate);
    //   }
    //   if (this.rebateAmount !== null && this.computePriceTotal) {
    //     let rd = numDiv(row.rproductPriceAdd, this.computePriceTotal); // 金额比例
    //     let thisrd = MathMulti(this.rebateAmount, rd);
    //     rel = Subtr(rel, thisrd);
    //     row.rproductActualPriceAdd = Number(MathMulti(Number(rel), this.communicationOrderDiscount ? this.communicationOrderDiscount : 1));
    //     return MathMulti(rel, this.communicationOrderDiscount === null ? 1 : this.communicationOrderDiscount);
    //   }
    //   row.rproductActualPriceAdd = Number(MathMulti(Number(rel), this.communicationOrderDiscount ? this.communicationOrderDiscount : 1));
    //   return rel;
    // },
    removeProduct (index) {
      this.$confirm('是否删除该产品?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let list = this.productList;
        this.productList = [];
        this.$nextTick(() => {
          list.splice(index, 1);
          list.forEach((item) => {
            if (item.itemIndex > index) {
              item.itemIndex = item.itemIndex - 1;
            }
          });
          this.productList = list;
        });
      }).catch(() => {

      });
    },
    copyRow (row, index) {
      let newRow = JSON.parse(JSON.stringify(row));
      newRow.id = null;
      this.productList.splice(index + 1, 0, newRow);
      this.$nextTick(() => {
        for (let i = 0; i < this.productList.length; i++) {
          this.productList[i].itemIndex = i;
        }
      });
    },
    addNewRow () {
      this.productList.push({
        rproductPriceAdd: 0,
        rproductActualPriceAdd: 0,
        rmaterialNum: '',
        rexpectedDeliveryDate: '',
        rfreightProperties: '',
        rmaterialUnit: '',
        rproductCode: '',
        rproductName: '',
        rproductUnit: '',
        rproductNum: 0,
        rproductPrice: 0,
        rbeforeSplitPrice: 0,
        rorganization: '',
        rproductInvoiceName: '',
        rproductSalesName: '',
        removeVisible: false,
        addNew: true
      });
    },
    setMaterialNum (row, index) {
      let productAndMaterialGroup = [];
      let MaterialNumValues = {};
      if (!row) {
        this.productList.forEach((item, index) => {
          if (item.rproductCode) {
            productAndMaterialGroup.push({
              productSalesCode: item.rproductCode,
              productName: item.rproductName,
              exclusiveMaterial: item.rmaterialNum || '',
              productNum: item.rproductNum,
              isHavePowerCord: item.isHavePowerCord || false,
              isTestOrder: item.rIsBorrowToSale || false
            });
            MaterialNumValues[item.rproductCode] = {
              materialNumberId: item.rmaterialNum,
              materialUnit: item.rmaterialUnit
            };
          }
        });
      } else {
        if (row.rproductCode) {
          productAndMaterialGroup.push({
            productSalesCode: row.rproductCode,
            productName: row.rproductName,
            exclusiveMaterial: row.rmaterialNum,
            productNum: row.rproductNum,
            isHavePowerCord: row.isHavePowerCord || false,
            isTestOrder: row.rIsBorrowToSale || false
          });
          MaterialNumValues[row.rproductCode] = {
            materialNumberId: row.rmaterialNum,
            materialUnit: row.rmaterialUnit
          };
        } else {
          return;
        }
      }
      let param = {
        contractType: '',
        contractNumber: this.form.rnewContractNum,
        contractName: this.form.rprojectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };
      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },
    chooseMateria ({ list, RowIndex }) {
      if (RowIndex === 'all') {
        let cx = 0;
        this.productList.forEach((pro, index) => {
          let mate = list[index - cx];
          if (pro.rproductCode === mate.productSalesCode) {
            pro.rmaterialNum = mate.selected;
            // 兼容字段materialUnit为空的时候
            pro.rmaterialUnit = mate.materialUnit || '';
            pro.softFlag = mate.softFlag || '';
          }
          if (pro.exclusiveMaterialNumber) {
            cx++;
          }
        });
      } else {
        this.productList[RowIndex].rmaterialNum = list[0].selected;
        this.productList[RowIndex].rmaterialUnit = list[0].materialUnit;
        this.productList[RowIndex].softFlag = list[0].softFlag;
      }
    },
    clickBorrow (row, index) {
      if (row.rIsBorrowToSale) {
        this.productList[index].rfreightProperties = '20';
        productOldData[index] = this.$cloneDeep(row);
        row.minExpectedDate = dayjs().format('YYYY-MM-DD 00:00:00');
        row.maxExpectedDate = null;
        row.holidayDates = null;
      } else {
        this.productList[index].rfreightProperties = '';
        row.minExpectedDate = productOldData[index].minExpectedDate;
        row.maxExpectedDate = productOldData[index].maxExpectedDate;
        row.holidayDates = productOldData[index].holidayDates;
      }
    },
    async Recalculation () {
      await this.$nextTick();
      // this.productList.forEach((item) => {
      //   this.getOrderAmount(item);
      // });
    }
  },
  mounted () {
    productOldData = {};
    this.initData();
  },
  watch: {
    productData (val) {
      // debugger;
      this.productList = val[0].addressList[0].contractProductList;
      // var date = new Date();
      // var mon = date.getMonth() + 1;
      // var day = date.getDate();
      // var currDate = date.getFullYear() + '-' + (mon < 10 ? '0' + mon : mon) + '-' + (day < 10 ? '0' + day : day);
      // this.productList.forEach((item) => {
      //   item.rExpectedDeliveryDate = currDate;
      // });
    },
    productList (val) {
      this.Recalculation();
    },
    isTestProject () {
      this.Recalculation();
    },
    salesType () {
      this.Recalculation();
    },
    communicationOrderDiscount () {
      this.Recalculation();
    },
    contractId (val) {
    }
  },
  filter: {
    rounding (value) {
      return value.toFixed(2);
    }
  }
};
</script>
<style lang="scss" scoped>
  .productTable{
    .el-table__footer-wrapper tbody td{
      background: #fff;
    }
  }
  /* adress
-------------------------- */
  .adressBox{
    display: inline-block;
    .item{
      display: inline-block;
      margin-right: 6px;
    }
    .defTab{
      padding: 3px 10px;
      display: inline-block;
      background: #1b73ff;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      margin-right: 15px;
    }
  }
  .table{
    background: #00ff00;
  }
</style>
<style lang="scss">
  .orderProductList{
    // .table{
    //   .el-table{
    //    .red-row {
    //       background:  #f0f9eb;
    //       }
    //     .cell{
    //       padding-left: 0;
    //       padding-right: 0;
    //     }
        .el-table__footer-wrapper {
            // position: absolute;
            // left: 0;
            // bottom: 0;
            // z-index: 3;
        }
    //   }
    // }
  }

.text-left{
  text-align: left;
}
</style>
